import React from "react";
import { Options } from "./Options";

export const Profile = ({
  name,
  ocupation,
  location,
  email,
  portfolio,
  portfolioLabel,
  image,
}) => {
  return (
    <section className="home hero" id="home">
      <div className="hero-card card bd-grid">
        <div className="hero-content">
          <div className="hero-avatar">
            <img src={image} alt="profile" className="home-img" />
          </div>
          <div className="hero-text">
            <h1 className="home-title">{name}</h1>
            <h3 className="home-profession">{ocupation}</h3>
          </div>
        </div>

        <div className="home-address">
          <span className="home-information">
            <i className="bx bx-map home-icon" /> {location}
          </span>
          <a className="home-information" href={`mailto:${email}`}>
            <i className="bx bx-envelope home-icon" /> {email}
          </a>
          {portfolio && (
            <a
              className="home-information"
              href={portfolio}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bx bx-link-external home-icon" aria-hidden="true" /> {portfolioLabel || "Portfolio"}
            </a>
          )}
        </div>
      </div>
      <Options />
    </section>
  );
};